export interface IFormStore {
  setStateInvalid(): void;
  setDataValid(model: any): void;
}
